/* 예정 모임 화면 미리보기 — 데이터 없이 레이아웃을 확인할 때 씁니다 (/ds/upcoming). */
import { MeetingUpcomingView } from 'components/meeting/MeetingUpcomingView';

const meeting = {
    name: '가을밤 와인 한 잔',
    meetingType: 'DAY',
    isRegularMeeting: false,
    date: '2026년 9월 12일 (토)',
    time: '오후 7:00',
    location: '연남동 와인바 보떼',
    locationDetail: '서울 마포구 연희로1길 41 1층',
    latitude: 37.5602,
    longitude: 126.9256,
    inviteCode: 'CREW-4K8211',
    meetingTime: '오후 7:00',
};

const members = [
    { userNo: 1, nickname: '윤재권', attendanceStatus: 'ATTENDING' },
    { userNo: 2, nickname: '이수진', attendanceStatus: 'ATTENDING' },
    { userNo: 3, nickname: '박민수', attendanceStatus: 'UNDECIDED' },
    { userNo: 4, nickname: '최지영', attendanceStatus: 'NOT_ATTENDING' },
    { userNo: 5, nickname: '한도윤', attendanceStatus: 'UNDECIDED' },
];

const participants = members.map((m, i) => ({
    id: m.userNo,
    userNo: m.userNo,
    name: m.nickname,
    isCreator: i === 0,
    isMe: i === 0,
    locationSharing: i % 2 === 0,
    status: m.attendanceStatus === 'ATTENDING' ? 'confirmed'
        : m.attendanceStatus === 'NOT_ATTENDING' ? 'declined' : 'pending',
}));

export const UpcomingPreview = () => (
    <MeetingUpcomingView
        meeting={meeting}
        members={members}
        participants={participants}
        isCreator
        isMember
        meetingId="preview"
        startMs={Date.now() + 1000 * 60 * 60 * 26}
        subPlaces={[
            {
                subPlaceId: 11, category: 'SECONDARY', placeName: '연남 커피로스터스',
                placeAddress: '서울 마포구 성미산로 161', visitTime: '21:00', sortOrder: 1,
            },
        ]}
        isJoining={false}
        onJoinMeeting={() => {}}
        onShare={() => {}}
        onOpenInviteFromPast={() => {}}
        onEdit={() => {}}
        onChangeAttendance={() => {}}
        isLocationSharing
        onToggleLocationSharing={() => {}}
        attendanceStatus="attending"
    />
);
